import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Crown, ShieldCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Admin");
      nav("/admin");
    } catch (err) {
      const msg = err.response?.data?.detail || "Login failed";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell min-h-screen flex items-center justify-center p-4 relative" data-testid="admin-login-page">
      <div className="absolute inset-0 crown-grid-bg pointer-events-none opacity-50" />
      <div className="relative w-full max-w-md fade-up">
        <Link to="/" className="inline-flex items-center gap-2 text-[#b0b0b0] hover:text-gold mb-6 text-sm" data-testid="back-home-link">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>
        <div className="glass rounded-3xl p-8 gold-glow">
          <div className="text-center mb-8">
            <div className="w-16 h-16 rounded-2xl gold-gradient flex items-center justify-center mx-auto mb-4 gold-glow">
              <Crown className="w-9 h-9 text-black" />
            </div>
            <h1 className="font-display text-3xl font-extrabold gold-text-gradient">Admin Panel</h1>
            <p className="text-[#b0b0b0] text-sm mt-2">Sign in to manage Royal Games Markets</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label-gold block mb-2">Email</label>
              <input
                type="email"
                className="input-gold"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@royalgames.com"
                required
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="label-gold block mb-2">Password</label>
              <input
                type="password"
                className="input-gold"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                data-testid="login-password-input"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-gold w-full !py-3" data-testid="login-submit-button">
              <ShieldCheck className="w-5 h-5" />
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
